import { ReactNode } from 'react';
import {
  CallEvent,
  EventType,
} from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records-ext/call-path/v1/api.pb';
import { renderAIAgent } from '../components/ai/ai-receptionist-event-renderer';
import {
  renderCondition,
  renderDevice,
  renderCallEnded,
  renderPlayMedia,
  renderForwarded,
  renderCallQueue,
  renderCallGroup,
} from '../components/event-renderer';
import { renderIVR } from '../components/ivr/ivr-render-event-renderer';
import { renderVoicemailPrompt } from '../components/voicemail/voicemail-render-event-renderer';

export interface EventRendererContext {
  callerName?: string;
  userName?: string;
  isSecondToLast?: boolean;
  isCreditEnforcementEnabled?: boolean;
  hasFullPhoneAccess?: boolean;
}

export type EventRenderer = (event: CallEvent, context: EventRendererContext) => ReactNode;

const eventRendererMap = {
  [EventType.EVENT_TYPE_AI_AGENT]: renderAIAgent,
  [EventType.EVENT_TYPE_CONDITION]: renderCondition,
  [EventType.EVENT_TYPE_DEVICE]: renderDevice,
  [EventType.EVENT_TYPE_CALL_ENDED]: renderCallEnded,
  [EventType.EVENT_TYPE_PLAY_MEDIA]: renderPlayMedia,
  [EventType.EVENT_TYPE_FORWARDED]: renderForwarded,
  [EventType.EVENT_TYPE_VOICEMAIL_PROMPT]: renderVoicemailPrompt,
  [EventType.EVENT_TYPE_CALL_QUEUE]: renderCallQueue,
  [EventType.EVENT_TYPE_CALL_GROUP]: renderCallGroup,
  [EventType.EVENT_TYPE_IVR]: renderIVR,
  [EventType.EVENT_TYPE_UNKNOWN]: () => null,
  [EventType.EVENT_TYPE_VOICEMAIL_CHECK]: () => null,
} satisfies Record<EventType, EventRenderer>;

export const renderEvent = (callDetail: CallEvent, context: EventRendererContext): ReactNode => {
  const eventType = callDetail.eventType;
  const renderer = eventRendererMap[eventType as EventType];
  return renderer ? renderer(callDetail, context) : null;
};
